import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  uri = environment.url;

  private _constants = new BehaviorSubject(null);

  get constants() {
    return this._constants.asObservable();
  }

  constructor(private http: HttpClient) {}

  fetchConstants() {
    return this.http.get(this.uri + `/api/v1/public`).pipe(
      tap((resp: any) => {
        const { constants } = resp.result;
        this._constants.next(constants);
      })
    );
  }
}
